export default __webpack_public_path__ + "static/dishroomLancet-da8fe1102615c7b20cf4d3c924d4d0d0.svg";